class BrixRichText {
  static init(...parameters) {
    return new BrixRichText(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;
      this.toggleReadMore();
    }
  }

  toggleReadMore() {
    const readMoreButton = this.block.querySelector('.rich-text-read-more');
    const hiddenBlocks = this.block.querySelectorAll('.rich-text-read-more ~ *');
    const hiddenBlocksIds = [...hiddenBlocks].map(block => block.id);
    const content = this.block.querySelector('.content');

    if (readMoreButton) {
      readMoreButton.setAttribute('aria-expanded', false);
      readMoreButton.setAttribute('aria-controls', hiddenBlocksIds.join(' '));

      const readLessButton = document.createElement('button');
      readLessButton.classList.add('rich-text-read-less');
      readLessButton.setAttribute('aria-expanded', false);
      readLessButton.setAttribute('aria-controls', hiddenBlocksIds.join(' '));

      const arrowIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      arrowIcon.setAttribute('viewBox', '0 0 14 9');

      const arrowIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      arrowIconPath.setAttribute('d', 'M12.2929 0.292892L13.7071 1.70711L7.00001 8.41421L0.292908 1.70711L1.70712 0.292892L7.00001 5.58579L12.2929 0.292892Z');

      arrowIcon.appendChild(arrowIconPath);
      readLessButton.appendChild(arrowIcon);
      content.appendChild(readLessButton);

      readMoreButton.addEventListener('click', () => {
        readMoreButton.classList.add('-show-more');
        readMoreButton.setAttribute('aria-expanded', true);
        readLessButton.setAttribute('aria-expanded', true);
        readLessButton.focus();
      });

      readLessButton.addEventListener('click', () => {
        readMoreButton.classList.remove('-show-more');
        readMoreButton.setAttribute('aria-expanded', false);
        readLessButton.setAttribute('aria-expanded', false);
        readMoreButton.focus();
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-rich-text', BrixRichText.init);
}
